import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=5b812c70&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"
import style0 from "./Game.vue?vue&type=style&index=0&id=5b812c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b812c70",
  null
  
)

export default component.exports